import styled from 'styled-components'

export const Input = styled.input`
  opacity: 0;
`
